import { NavigationGuard } from 'vue-router';

import { getViewer } from '@/composables/useViewer';

const unauthenticatedGuard: NavigationGuard = async (to, __, next) => {
  const viewer = await getViewer();
  if (viewer !== null) {
    return next('/');
  }

  return next();
};

export default unauthenticatedGuard;
